import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
    const { currentUser, loading } = useContext(AuthContext);

    // Afficher un loader pendant que Firebase vérifie si l'utilisateur est connecté
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="w-12 h-12 border-4 border-gray-200 border-t-black rounded-full animate-spin"></div>
            </div>
        );
    }

    // Une fois le chargement terminé, rediriger si pas connecté
    if (!currentUser) {
        return <Navigate to="/login" />; // Redirige vers la page de connexion si non connecté
    }

    return children; // Affiche les enfants si connecté
};

export default PrivateRoute;
